/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Column_RegisterInputs */

const id_tld_pricing_column_register = /** @type {(inputs: Tld_Pricing_Column_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrasi`)
};

const en_tld_pricing_column_register = /** @type {(inputs: Tld_Pricing_Column_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Register`)
};

/**
* | output |
* | --- |
* | "Register" |
*
* @param {Tld_Pricing_Column_RegisterInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_column_register = /** @type {((inputs?: Tld_Pricing_Column_RegisterInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Column_RegisterInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_column_register(inputs)
	return id_tld_pricing_column_register(inputs)
});